/** API route map: URLS.Controller.JobSkill */
export const JobSkill = {
      Name: 'JobSkills/',
      GetJobAssignSkills: 'get-job-assign-skills',
      SearchJobSkills: 'search-job-skills',
      AddJobAssignSkill: 'add-job-assign-skill',
      UpdateJobAssignSkill: 'update-job-assign-skill',
      UpsertJobSkill: 'upsert-job-skills',
      DeleteJobSkill: 'delete-job-skill',
      GetJobSkills: 'get-job-skills',
      AddNewSkills: 'add-new-skills',
};
